import { Injectable } from '@angular/core';
import { Router, CanLoad, Route, UrlSegment } from '@angular/router';
import { from, Observable } from 'rxjs';
import { tap, take } from 'rxjs/operators';
import { UserService } from '../User/Service/user.service';
import { GlobalConstants } from '../utils/global-constants';

@Injectable({
  providedIn: 'root',
})
export class ModuleAuthenticationGuard implements CanLoad {
  constructor(
    private readonly router: Router,
    private readonly userService: UserService,
  ) {}
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | boolean {
    if (this.userService.isLoggedin) return true;
    return from(this.userService.isLoggedin$).pipe(
      take(1),
      tap((loggedIn) => {
        if (!loggedIn) {
          this.router.navigate(['/']);
        } else if (
          !this.userService.authUserInfo[GlobalConstants.roleClaim].includes(
            'User',
          )
        )
          if (
            this.userService.authUserInfo[GlobalConstants.roleClaim].includes(
              'Executor',
            )
          )
            this.router.navigate(['/executor']);
          else if (
            this.userService.authUserInfo[GlobalConstants.roleClaim].includes(
              'Financial Planner',
            )
          )
            this.router.navigate(['/authprofessional']);
      }),
    );
  }
}
